exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pyramid-chart ul.legend{padding-left:0;list-style:none}.pyramid-chart ul.legend>li{background:#f7f7f7;padding:5px;margin-top:30px;border-radius:4px}.pyramid-chart ul.legend>li .key{width:16px;height:16px;border-radius:8px;background:#000;display:inline-block}.pyramid-chart ul.legend>li .description{display:inline-block;font-size:10px;font-weight:500;text-transform:uppercase}.pyramid-chart svg{width:100%;height:auto}.pyramid-chart svg .pyramid-group{cursor:pointer}.pyramid-chart svg .pyramid-group text{fill:#fff}.pyramid-chart svg .pyramid-group text.description{font-size:16px}.pyramid-chart svg .pyramid-group text.amount{font-size:28px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-731875fc","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/Components/Charts/Pyramid.vue
// module id = 399
// module chunks = 0